import React, { useContext } from "react";
import { Paper, Grid, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Footer from "../homeslide/Footer";
import { LangContext } from "../../../Context/Langcontext";
import useReactRouter from "use-react-router";

const useStyle = makeStyles((theme) => ({
  Position: {
    height: "100%",
    width: "100%",
    background: "#FFFFFF",
  },
  PaperSize: {
    width: "100%",
    height: "32%",
    background: "#FFFFFF",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    maxWidth: "90%",
    boxShadow: "unset",
  },
  root: { width: "100%", height: "100%" },
  btnstyle: {
    margin: "1rem",
    borderRadius: 8,
    padding: "0.3rem 3rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    marginTop: "2rem",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#E16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  itemcenter: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  maintext: {
    fontSize: "1.5rem",
    color: "#595A5A",
    fontWeight: 700,
  },
  secondtext: {
    fontSize: "1.2rem",
    color: "#595A5A",
    fontWeight: 200,
    maxWidth: "80%",
  },
  itemflexend: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  center: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const StartNow = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history } = useReactRouter();
  return (
    <div className={classes.Position}>
      <div className={classes.center}>
        <Paper className={classes.PaperSize}>
          <Grid container className={classes.root}>
            <Grid item md={8} sm={12} style={{ padding: "2.25rem" }}>
              <div className={classes.itemcenter}>
                <Typography className={classes.maintext}>
                  {lang.GetStartNow}
                </Typography>
                {/* <Typography className={classes.secondtext}>
                Usu habeo equidem sanctus no. Suas summo id sed, erat erant
                oporteat cu pri. In eum omnes molestie. Sed ad debet scaevola,
                ne mel.
              </Typography> */}
              </div>
            </Grid>
            <Grid item md={4} sm={12} style={{ padding: "2.25rem" }}>
              <div className={classes.itemflexend}>
                <Button
                  className={classes.btnstyle}
                  onClick={() => {
                    history.push("/user/register");
                  }}
                >
                  {lang.CreateAccount}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </div>

      <Footer />
    </div>
  );
};

export default StartNow;
